import { gql } from "@apollo/client";
import {TypeDefinitionAttributeFields} from "../fragments/typeDefinitionAttribute";

export const InstalledBaseNodeListTdas = gql`
    query InstalledBaseNodeListTdas (
        $typeDefinitionIndex: InstalledBaseNodeTypeDefinitionIndex!,
        $options: InstalledBaseNodeTypeDefinitionAttributeListOptionsInput
    ) {
        installedBaseNodeList {
            typeDefinitionAttributeList (typeDefinitionIndex: $typeDefinitionIndex, options: $options) {
                total
                typeDefinitionAttributes {
                    ...TypeDefinitionAttributeFields
                }
            }
        }
    }
    ${TypeDefinitionAttributeFields}
`;
